export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const

type PageSizeSelectProps = {
  value: number
  onChange: (size: number) => void
}

const PageSizeSelect = ({ value, onChange }: PageSizeSelectProps) => (
  <div className="flex items-center gap-2">
    <div className="flex items-center gap-1" role="group" aria-label="Rows per page">
      {PAGE_SIZE_OPTIONS.map((size) => (
        <button
          key={size}
          type="button"
          onClick={() => {
            if (size !== value) onChange(size)
          }}
          className="px-2 sm:px-3 py-1 rounded hover:opacity-90 transition-opacity"
          style={{
            fontFamily: 'Lexend Deca',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '22px',
            color: value === size ? '#FFFFFF' : '#212126',
            backgroundColor: value === size ? '#212126' : 'transparent',
            border: '1px solid #E9E9EA',
          }}
        >
          {size}
        </button>
      ))}
    </div>
    <span aria-hidden className="hidden sm:block w-px self-stretch min-h-[20px]" style={{ backgroundColor: '#E9E9EA' }} />
  </div>
)

export default PageSizeSelect
